import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router";
import {
  Row,
  Col,
  Breadcrumb,
  Button,
  Modal,
  Alert,
  OverlayTrigger,
  Tooltip,
  Tabs,
  Tab,
  Spinner
} from "react-bootstrap";
import API from "../Utility";
import { LinkContainer } from "react-router-bootstrap";
import { Formik, Form, Field, ErrorMessage, useField } from "formik";
import * as Yup from "yup";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {
  FaRegTrashAlt,
  FaCode,
  FaEdit
} from "react-icons/fa";
import { LuRefreshCcw } from 'react-icons/lu';

// Styles
import "./SitesSingleView.scss";
import PubHubAsset from "../PubHubAsset";

export default function SitesSingleView({ children, location, ...routeProps }) {
  let { project, siteId } = useParams();
  let history = useHistory();

  const formMode = "update";

  const [siteData, setSiteData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteMessageShow, setDeleteMessageShow] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submittingForm, setSubmittingForm] = useState(false);

  // const [loadingIconAsset, setLoadingIconAsset] = useState(undefined);
  const [faviconAsset, setFaviconAsset] = useState(undefined);
  const [logoAsset, setLogoAsset] = useState(undefined);
  const [backgroundImageAsset, setBackgroundImageAsset] = useState(undefined);
  const [backgroundImageMobileAsset, setBackgroundImageMobileAsset] = useState(undefined);

  const [authType, setAuthType] = useState([]);

  const [samlClaims, setSamlClaims] = useState([]);
  const [oidcClaims, setOIDCClaims] = useState([]);
  const [showAddClaimModal, setShowAddClaimModal] = useState(false);
  const [claimToEdit, setClaimToEdit] = useState(null);
  const [generatingOIDCConfig, setGeneratingOIDCConfig] = useState(false);
  const [OIDCConfigURL, setOIDCConfigURL] = useState(null);
  const [generatingOIDCConfigResponse, setGeneratingOIDCConfigResponse] = useState(null);

  async function getSiteData(query) {
    try {
      setSiteData([]);
      setIsLoading(true);
      const siteApiData = await API.get({
        url: query.url,
      });
      setIsLoading(false);
      setSiteData(siteApiData);
      // if (siteApiData?.brandingConfig?.loadingIcon?.image) {
      //   setLoadingIconAsset(siteApiData.brandingConfig.loadingIcon.image);
      // }
      if (siteApiData?.brandingConfig?.favicon?.image) {
        setFaviconAsset(siteApiData.brandingConfig.favicon.image);
      }
      if (siteApiData?.brandingConfig?.logo?.image) {
        setLogoAsset(siteApiData.brandingConfig.logo.image);
      }
      if (siteApiData?.brandingConfig?.backgroundImage?.image) {
        setBackgroundImageAsset(siteApiData.brandingConfig.backgroundImage.image);
      }
      if (siteApiData?.brandingConfig?.backgroundImageMobile?.image) {
        setBackgroundImageMobileAsset(siteApiData.brandingConfig.backgroundImageMobile.image);
      }
      if (siteApiData?.authenticationConfig?.authType) {
        setAuthType(siteApiData.authenticationConfig.authType);
      }
      if (siteApiData?.authenticationConfig?.saml?.claims) {
        setSamlClaims(siteApiData.authenticationConfig.saml.claims);
      }
      if (siteApiData?.authenticationConfig?.oidc?.claims) {
        setOIDCClaims(siteApiData.authenticationConfig.oidc.claims);
      }
      if (siteApiData?.authenticationConfig?.oidc?.configUrl) {
        setOIDCConfigURL(siteApiData.authenticationConfig.oidc.configUrl);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    async function initializeData() {
      await getSiteData({
        url: `/admin/${project}/sites/${siteId}`,
      });
    }

    initializeData();
  }, []);

  const tooltipPlacement = "top";
  const tooltipTitle = "Warning";

  const loading = () => {
    return !siteData?._id && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>Site not found</span>
      </div>
    );
  };

  // Initialize form validation
  let formValidation = {
    name: Yup.string()
      .min(1, "Must be longer than 1 character")
      .required("Name is required"),
    description: Yup.string(),
    domain: Yup.string()
      .min(1, "Must be longer than 1 character")
      .required("Domain is required"),
  };

  // Initialize form fields
  let formFields = {
    name:
      siteData && siteData.name
        ? siteData.name
        : undefined,
    description:
      siteData && siteData.description
        ? siteData.description
        : undefined,
    domain:
      siteData && siteData.domain
        ? siteData.domain
        : undefined,
    customDomain:
      siteData && siteData.customDomain
        ? siteData.customDomain
        : undefined,
    googleTagManagerContainerId:
      siteData && siteData.googleTagManagerContainerId
        ? siteData.googleTagManagerContainerId
        : undefined,
    workflowTitle:
      siteData && siteData.workflowsConfig && siteData.workflowsConfig.title
        ? siteData.workflowsConfig.title
        : undefined,
    workflowBlankMessage:
      siteData && siteData.workflowsConfig && siteData.workflowsConfig.blankMessage
        ? siteData.workflowsConfig.blankMessage
        : undefined,
    primaryColour:
      siteData && siteData.brandingConfig && siteData.brandingConfig.primaryColour
        ? siteData.brandingConfig.primaryColour
        : undefined,
    textColour:
      siteData && siteData.brandingConfig && siteData.brandingConfig.textColour
        ? siteData.brandingConfig.textColour
        : undefined,
    authType:
      siteData && siteData.authenticationConfig && siteData.authenticationConfig.authType
        ? siteData.authenticationConfig.authType
        : undefined,
    samlIdpLoginUrl:
      siteData && siteData.authenticationConfig && siteData.authenticationConfig.saml && siteData.authenticationConfig.saml.idpLoginUrl
        ? siteData.authenticationConfig.saml.idpLoginUrl
        : undefined,
    samlIdpLogoutUrl:
      siteData && siteData.authenticationConfig && siteData.authenticationConfig.saml && siteData.authenticationConfig.saml.idpLogoutUrl
        ? siteData.authenticationConfig.saml.idpLogoutUrl
        : undefined,
    allowFormsAuth: siteData && siteData.authenticationConfig && siteData.authenticationConfig.allowFormsAuth,
    oidcIdentityProviderID:
      siteData && siteData.authenticationConfig && siteData.authenticationConfig.oidc && siteData.authenticationConfig.oidc.identityProviderID
        ? siteData.authenticationConfig.oidc.identityProviderID
        : undefined,
    oidcClientID:
      siteData && siteData.authenticationConfig && siteData.authenticationConfig.oidc && siteData.authenticationConfig.oidc.clientID
        ? siteData.authenticationConfig.oidc.clientID
        : undefined,
    oidcConfigUrl:
      siteData && siteData.authenticationConfig && siteData.authenticationConfig.oidc && siteData.authenticationConfig.oidc.configUrl
        ? siteData.authenticationConfig.oidc.configUrl
        : undefined,
  };

  const updateSiteConfig = async (values) => {
    try {
      const apiCallConfig = {
        url: `/admin/${project}/sites/${siteId}`,
        data: values,
      };
      setSubmittingForm(true);
      const response = await API.put(apiCallConfig);
      if (response) {
        if (response.modified) {
          // success
          setSubmitSuccess("Site updated successfully");
          setSiteData(response);
        } else {
          // console.log(response);
          setSubmitError(response?.response?.data?.message || response.message || response);
        }
        setSubmittingForm(false);
        setTimeout(() => {
          setSubmitError(null);
          setSubmitSuccess(null);
        }, 2000);
      }
    } catch (error) {
      if (error.response) {
        setSubmitError(error?.response?.data?.message || "An error occurred, please try again");
      } else {
        setSubmitError("An error occurred, please try again");
      }
      setSubmittingForm(false);
      setTimeout(() => {
        setSubmitError(null);
        setSubmitSuccess(null);
      }, 2000);
    }
  };

  const handleSubmit = (values) => {
    let formattedData = {};
    setSubmitSuccess(null);
    setSubmitError(null);
    if (values) {
      // Basics
      if (values.name && values.name !== "") {
        formattedData.name = values.name;
      }
      if (values.description && values.description !== "") {
        formattedData.description = values.description;
      }
      if (values.domain && values.domain !== "") {
        formattedData.domain = values.domain;
      }
      if (values.customDomain && values.customDomain !== "") {
        formattedData.customDomain = values.customDomain;
      }
      if (values.googleTagManagerContainerId && values.googleTagManagerContainerId !== "") {
        formattedData.googleTagManagerContainerId = values.googleTagManagerContainerId;
      }
      if (values.workflowTitle && values.workflowTitle !== "") {
        formattedData.workflowsConfig = formattedData.workflowsConfig || {};
        formattedData.workflowsConfig.title = values.workflowTitle;
      }
      if (values.workflowBlankMessage && values.workflowBlankMessage !== "") {
        formattedData.workflowsConfig = formattedData.workflowsConfig || {};
        formattedData.workflowsConfig.blankMessage = values.workflowBlankMessage;
      }

      // Branding
      // if (loadingIconAsset) {
      //   if (!formattedData?.brandingConfig?.loadingIcon) {
      //     formattedData.brandingConfig = formattedData.brandingConfig || {};
      //     formattedData.brandingConfig.loadingIcon = formattedData.brandingConfig.loadingIcon || {};
      //   }
      //   formattedData.brandingConfig.loadingIcon.image = loadingIconAsset;
      // }
      if (faviconAsset) {
        if (!formattedData?.brandingConfig?.favicon) {
          formattedData.brandingConfig = formattedData.brandingConfig || {};
          formattedData.brandingConfig.favicon = formattedData.brandingConfig.favicon || {};
        }
        formattedData.brandingConfig.favicon.image = faviconAsset;
      }
      if (logoAsset) {
        if (!formattedData?.brandingConfig?.logo) {
          formattedData.brandingConfig = formattedData.brandingConfig || {};
          formattedData.brandingConfig.logo = formattedData.brandingConfig.logo || {};
        }
        formattedData.brandingConfig.logo.image = logoAsset;
      }
      if (backgroundImageAsset) {
        if (!formattedData?.brandingConfig?.backgroundImage) {
          formattedData.brandingConfig = formattedData.brandingConfig || {};
          formattedData.brandingConfig.backgroundImage = formattedData.brandingConfig.backgroundImage || {};
        }
        formattedData.brandingConfig.backgroundImage.image = backgroundImageAsset;
      }
      if (backgroundImageMobileAsset) {
        if (!formattedData?.brandingConfig?.backgroundImageMobile) {
          formattedData.brandingConfig = formattedData.brandingConfig || {};
          formattedData.brandingConfig.backgroundImageMobile = formattedData.brandingConfig.backgroundImageMobile || {};
        }
        formattedData.brandingConfig.backgroundImageMobile.image = backgroundImageMobileAsset;
      }
      if (values.primaryColour && values.primaryColour !== "") {
        formattedData.brandingConfig = formattedData.brandingConfig || {};
        formattedData.brandingConfig.primaryColour = values.primaryColour;
      }
      if (values.textColour && values.textColour !== "") {
        formattedData.brandingConfig = formattedData.brandingConfig || {};
        formattedData.brandingConfig.textColour = values.textColour;
      }

      // Access
      if (values.authType && values.authType !== "") {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.authType = values.authType;
      }
      if (values.samlIdpLoginUrl && values.samlIdpLoginUrl !== "") {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.saml = formattedData.authenticationConfig.saml || {};
        formattedData.authenticationConfig.saml.idpLoginUrl = values.samlIdpLoginUrl;
      }
      if (values.samlIdpLogoutUrl && values.samlIdpLogoutUrl !== "") {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.saml = formattedData.authenticationConfig.saml || {};
        formattedData.authenticationConfig.saml.idpLogoutUrl = values.samlIdpLogoutUrl;
      }
      if (samlClaims?.[0]) {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.saml = formattedData.authenticationConfig.saml || {};
        formattedData.authenticationConfig.saml.claims = samlClaims;
      }
      if (values.allowFormsAuth) {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.allowFormsAuth = values.allowFormsAuth;
      }
      if (values.oidcIdentityProviderID && values.oidcIdentityProviderID !== "") {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.oidc = formattedData.authenticationConfig.oidc || {};
        formattedData.authenticationConfig.oidc.identityProviderID = values.oidcIdentityProviderID;
      }
      if (values.oidcClientID && values.oidcClientID !== "") {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.oidc = formattedData.authenticationConfig.oidc || {};
        formattedData.authenticationConfig.oidc.clientID = values.oidcClientID;
      }
      if (values.oidcConfigUrl && values.oidcConfigUrl !== "") {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.oidc = formattedData.authenticationConfig.oidc || {};
        formattedData.authenticationConfig.oidc.configUrl = values.oidcConfigUrl;
      }
      if (oidcClaims?.[0]) {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.oidc = formattedData.authenticationConfig.oidc || {};
        formattedData.authenticationConfig.oidc.claims = oidcClaims;
      }
      if (siteData?.authenticationConfig?.oidc?.configData) {
        formattedData.authenticationConfig = formattedData.authenticationConfig || {};
        formattedData.authenticationConfig.oidc = formattedData.authenticationConfig.oidc || {};
        formattedData.authenticationConfig.oidc.configData = siteData.authenticationConfig.oidc.configData;
      }
    }
    updateSiteConfig(formattedData);
  };

  useEffect(() => {
    if (showAddClaimModal === false) {
      setClaimToEdit(null);
    }
  }, [showAddClaimModal]);

  useEffect(() => {
    if (generatingOIDCConfigResponse) {
      setTimeout(() => {
        setGeneratingOIDCConfigResponse(null);
      }
      , 2000);
    }
  }, [generatingOIDCConfigResponse]);

  const addNewSAMLClaim = () => {
    setShowAddClaimModal(true);
  };

  const addNewOIDCClaim = () => {
    setShowAddClaimModal(true);
  };

  const confirmNewClaim = (claim) => {
    if (authType === 'samlsso') {
      if (claimToEdit?.index !== undefined) {
        let newClaims = [...samlClaims];
        newClaims[claimToEdit.index] = claim;
        setSamlClaims(newClaims);
      } else {
        let newClaims = [...samlClaims];
        newClaims.push(claim);
        setSamlClaims(newClaims);
      }
    }
    if (authType === 'oidcsso') {
      if (claimToEdit?.index !== undefined) {
        let newClaims = [...oidcClaims];
        newClaims[claimToEdit.index] = claim;
        setOIDCClaims(newClaims);
      } else {
        let newClaims = [...oidcClaims];
        newClaims.push(claim);
        setOIDCClaims(newClaims);
      }
    }
  };

  const removeSAMLClaim = (index) => {
    let newClaims = [...samlClaims];
    newClaims.splice(index, 1);
    setSamlClaims(newClaims);
  };

  const removeOIDCClaim = (index) => {
    let newClaims = [...oidcClaims];
    newClaims.splice(index, 1);
    setOIDCClaims(newClaims);
  };

  const editSAMLClaim = (index) => {
    let newClaims = [...samlClaims];
    let claim = newClaims[index];
    setClaimToEdit({
      claim,
      index,
      type: 'saml'
    });
    setShowAddClaimModal(true);
  };

  const editOIDCClaim = (index) => {
    let newClaims = [...oidcClaims];
    let claim = newClaims[index];
    setClaimToEdit({
      claim,
      index,
      type: 'oidc'
    });
    setShowAddClaimModal(true);
  };

  const generateSAMLMetadata = () => {
    try {
      let url = `${API.phUrl}/admin/auth/saml/metadata/${siteId}`;
      window.open(url, '_blank');
    } catch (error) {
      console.log(error);
    }
  };

  const generateOpenIDConnectConfiguration = async () => {
    let newSiteData = { ...siteData };
    try {
      newSiteData.authenticationConfig = newSiteData.authenticationConfig || {};
      newSiteData.authenticationConfig.oidc = newSiteData.authenticationConfig.oidc || {};
      newSiteData.authenticationConfig.oidc.configData = null;
      setGeneratingOIDCConfig(true);

      let url = `/admin/auth/oidc/config/${siteId}`;

      const apiCallConfig = {
        url: url,
        data: { config_url: OIDCConfigURL },
      };
      const response = await API.post(apiCallConfig);
      if (response.data) {
        setGeneratingOIDCConfig(false);
        newSiteData.authenticationConfig.oidc.configData = response.data;
        setSiteData(newSiteData);
        setGeneratingOIDCConfigResponse({ type: 'success', message: 'Configuration generated successfully.' });
      } else {
        setGeneratingOIDCConfigResponse({ type: 'error', message: response.response.data.message });
        setGeneratingOIDCConfig(false);
        newSiteData.authenticationConfig.oidc.configData = null;
        setSiteData(newSiteData);
      }
    } catch (error) {
      setGeneratingOIDCConfigResponse({ type: 'error', message: 'Something went wrong. Please try again.' });
      setGeneratingOIDCConfig(false);
      newSiteData.authenticationConfig.oidc.configData = null;
      setSiteData(newSiteData);
      console.log(error);
    }
  };

  // const deleteSite = async () => {
  //   setDeleteModalShow(true);
  // };

  // const editSite = () => {
  //   history.push({
  //     pathname: `/sites/${project}/${siteId}/update`,
  //     state: { site: siteData },
  //   });
  // };

  // const confirmDelete = async (event, exitValue) => {
  //   if (exitValue === true) {
  //     setDeleteMessageShow(true);
  //     await deleteResponse({
  //       url: `/admin/${project}/sites/delete/${siteId}`,
  //       data: siteData,
  //     });
  //   } else {
  //     setDeleteModalShow(false);
  //   }
  // };

  // async function deleteResponse(query) {
  //   const response = await API.delete({
  //     url: query.url,
  //     data: query.data,
  //   });
  //   setDeleteModalShow(false);
  //   history.push(`/sites/${project}`);
  // }

  return (
    <div className='sites-single-view'>
      <Row>
        <Col>
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', marginRight: '0' }}>
              <div style={{ display: 'flex', flexDirection: 'row', fontSize: '30px', alignItems: 'center' }}>
                <LinkContainer to={`/sites/${project}`}>
                  <div className='clickable'><b>Sites</b></div>
                </LinkContainer>
                <div style={{ padding: '0 10px' }}>
                  <ArrowForwardIosIcon style={{ fontSize: '25px' }} />
                </div>
                <LinkContainer
                  to={
                    formMode === "create"
                      ? `sites/${project}`
                      : `/sites/${project}/${siteId}`
                  }
                >
                  <div><b>{formMode === "create" ? "New Site" : siteData?.name}</b></div>
                </LinkContainer>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}></div>
          </div>
          <br /><br />
        </Col>
      </Row>
      {siteData && siteData._id ? (
        <>
          {/* <Row>
            <Col>
              <h2>{siteData.name}</h2>
            </Col>

            <Col md="auto" style={{ display: 'none' }}>
              <>
                {siteData.status === 'Active' ? (
                  <OverlayTrigger
                    placement={tooltipPlacement}
                    overlay={
                      <Tooltip id="delete-tooltip-disabled">
                        <b>{tooltipTitle}</b>
                        <p>{"This site is active and deleting it could cause unexpected results."}</p>
                      </Tooltip>
                    }
                  >
                    <Button
                      className="float-right ml-2 mb-2"
                      variant="outline-primary"
                      onClick={deleteSite}
                    >
                      <FaRegTrashAlt style={{ verticalAlign: "middle" }} />
                      <span style={{ verticalAlign: "middle" }}>
                        Delete Site
                      </span>
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <Button
                    className="float-right ml-2 mb-2"
                    variant="outline-primary"
                    onClick={deleteSite}
                  >
                    <FaRegTrashAlt style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle" }}>Delete Site</span>
                  </Button>
                )}
                {siteData.status === 'Active' ? (
                  <OverlayTrigger
                    placement={tooltipPlacement}
                    overlay={
                      <Tooltip id="delete-tooltip-disabled">
                        <b>{tooltipTitle}</b>
                        <p>{"This site is active and editing it could cause unexpected results."}</p>
                      </Tooltip>
                    }
                  >
                    <Button
                      className="float-right mb-2"
                      variant="outline-primary"
                      onClick={editSite}
                    >
                      <FaEdit style={{ verticalAlign: "middle" }} />
                      <span style={{ verticalAlign: "middle" }}>Edit Site</span>
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <Button
                    className="float-right mb-2"
                    variant="outline-primary"
                    onClick={editSite}
                  >
                    <FaEdit style={{ verticalAlign: "middle" }} />
                    <span style={{ verticalAlign: "middle" }}> Edit Site</span>
                  </Button>
                )}
              </>
            </Col>
          </Row> */}
          <Row>
            <Col>
              <div className='page-tabs'>
                <Formik
                  initialValues={formFields}
                  validationSchema={Yup.object().shape(formValidation)}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                  }}
                >
                  {({ values, touched, errors, isSubmitting }) => (
                    <Form noValidate>
                      <Tabs
                        defaultActiveKey={'basics'}
                        id={'site-tabs'} >
                        <Tab eventKey={'basics'} title={'Basics'}>
                          <div>
                            <div><h3>Basics</h3></div>
                            <br></br>

                            {/* Name */}
                            <div className="form-group">
                              <label htmlFor="name">Name</label>
                              <Field
                                type="text"
                                name="name"
                                placeholder="Name"
                                className={`form-control`}
                                required
                              ></Field>
                              {errors.name && touched.name ? (
                                <div className="text-danger"><small>{errors.name}</small></div>
                              ) : null}
                            </div>

                            {/* Description */}
                            <div className="form-group">
                              <label htmlFor="description">Description</label>
                              <Field
                                type="text"
                                name="description"
                                placeholder="Description"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="description"
                                className="invalid-feedback"
                              />
                            </div>

                            {/* Domain */}
                            <div className="form-group domain mb-3">
                              <label htmlFor="domain">Domain</label>
                              <Field
                                type="text"
                                name="domain"
                                placeholder="Domain"
                                className={`form-control`}
                                render={({ field /* { name, value, onChange, onBlur } */ }) => (
                                  <div className="input-group">
                                    <input {...field}
                                      type="text"
                                      name="domain"
                                      placeholder="Domain"
                                      className={`form-control`}
                                      aria-label="Domain"
                                      aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">.futuretalent.co.za</span>
                                    </div>
                                  </div>
                                )}
                              ></Field>
                              {errors.domain && touched.domain ? (
                                <div className="text-danger"><small>{errors.domain}</small></div>
                              ) : null}
                            </div>

                            {/* Custom Domain */}
                            <div className="form-group">
                              <label htmlFor="customDomain">Custom Domain</label>
                              <Field
                                type="text"
                                name="customDomain"
                                placeholder="Custom Domain"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="customDomain"
                                className="invalid-feedback"
                              />
                            </div>

                            <br></br>
                            <div><h3>Analytics</h3></div>
                            <br></br>

                            {/* Google Tag Manager Container ID */}
                            <div className="form-group">
                              <label htmlFor="googleTagManagerContainerId">Google Tag Manager Container ID</label>
                              <Field
                                type="text"
                                name="googleTagManagerContainerId"
                                placeholder="Google Tag Manager Container ID"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="googleTagManagerContainerId"
                                className="invalid-feedback"
                              />
                            </div>

                            <br></br>
                            <div><h3>Workflows</h3></div>
                            <br></br>

                            {/* Title */}
                            <div className="form-group">
                              <label htmlFor="workflowTitle">Title</label>
                              <Field
                                type="text"
                                name="workflowTitle"
                                placeholder="Title"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="workflowTitle"
                                className="invalid-feedback"
                              />
                            </div>

                            {/* No Assigned Workflows Message */}
                            <div className="form-group">
                              <label htmlFor="workflowBlankMessage">No Assigned Workflows Message</label>
                              <Field
                                type="text"
                                name="workflowBlankMessage"
                                placeholder="No Assigned Workflows Message"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="workflowBlankMessage"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                        </Tab>
                        <Tab eventKey={'access'} title={'Access'}>
                          <div>
                            <div><h3>Configuration</h3></div>
                            <br></br>

                            {/* Authentication Type */}
                            {/* authenticationConfig */}
                            {/* <div id="authType">Picked</div> */}
                            <div role="group" aria-labelledby="authType">
                              <label>
                                <Field type="radio" name="authType" value="form" onChange={(e) => {
                                  values.authType = e.target.value;
                                  setAuthType(e.target.value);
                                }} />
                                {' '}
                                Forms authentication only
                              </label>
                              <br></br>
                              <label>
                                <Field type="radio" name="authType" value="samlsso" onChange={(e) => {
                                  values.authType = e.target.value;
                                  setAuthType(e.target.value);
                                }} />
                                {' '}
                                SSO via SAML
                              </label>
                              <br></br>
                              <label>
                                <Field type="radio" name="authType" value="oidcsso" onChange={(e) => {
                                  values.authType = e.target.value;
                                  setAuthType(e.target.value);
                                }} />
                                {' '}
                                SSO via OIDC
                              </label>
                            </div>

                            {values.authType === 'samlsso' && (
                              <>
                                <br></br>
                                <div><h3>SSO via SAML</h3></div>
                                <br></br>

                                {/* Identity Provider Log In URL */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label htmlFor="samlIdpLoginUrl">Identity Provider Log In URL</label>
                                  <Field
                                    type="text"
                                    name="samlIdpLoginUrl"
                                    placeholder="Identity Provider Log In URL"
                                    className={`form-control`}
                                  ></Field>
                                  <ErrorMessage
                                    component="div"
                                    name="samlIdpLoginUrl"
                                    className="invalid-feedback"
                                  />
                                </div>

                                {/* Identity Provider Log Out URL */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label htmlFor="samlIdpLogoutUrl">Identity Provider Log Out URL</label>
                                  <Field
                                    type="text"
                                    name="samlIdpLogoutUrl"
                                    placeholder="Identity Provider Log Out URL"
                                    className={`form-control`}
                                  ></Field>
                                  <ErrorMessage
                                    component="div"
                                    name="samlIdpLogoutUrl"
                                    className="invalid-feedback"
                                  />
                                </div>

                                {/* Generate Metadata */}
                                <div className="form-group">
                                  <button
                                    className='btn btn-outline-secondary'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      generateSAMLMetadata();
                                    }}
                                    type='button'
                                  >
                                    <FaCode style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-2px' }} />
                                    <span style={{ verticalAlign: "middle" }}>
                                      Generate Metadata
                                    </span>
                                  </button>
                                </div>

                                {/* SAML Claims */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label htmlFor="samlIdpLogoutUrl">SAML Claims</label>
                                  <br></br>
                                  <small>Warning: Contact support if you need to change claims, as changes may result in new users being created, with no access to past experiences lost</small>
                                  <br></br>
                                  <br></br>
                                  <div className='well'>
                                    {samlClaims?.[0] ? samlClaims.map((claim, index) => {
                                      return (
                                        <div key={`claim-${index}`} className='well' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                          <div style={{ display: 'flex', justifyContent: 'flex-start', flex: 1 }}>
                                            <div>
                                              Site property <b>{claim.key}</b> is mapped from IdP property <b>{claim.value}</b>
                                            </div>
                                          </div>
                                          <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                                            <div>
                                              <button
                                                className='btn btn-outline-secondary'
                                                style={{ marginRight: '10px' }}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  editSAMLClaim(index);
                                                }}
                                              >
                                                <FaEdit style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-5px' }} />
                                                <span style={{ verticalAlign: "middle" }}>
                                                Edit
                                                </span>
                                              </button>
                                              <button
                                                className='btn btn-outline-secondary'
                                                style={{ marginRight: '10px' }}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  removeSAMLClaim(index);
                                                }}
                                              >
                                                <FaRegTrashAlt style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-5px' }} />
                                                <span style={{ verticalAlign: "middle" }}>
                                                Delete
                                                </span>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }) : (
                                      <>
                                        <div className='well'>
                                          <small>You have no claims defined.</small>
                                        </div>
                                        <br></br>
                                      </>
                                    )}
                                    <button
                                      className='btn btn-outline-secondary'
                                      style={{ marginRight: '10px' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        addNewSAMLClaim();
                                      }}
                                    >
                                      <span style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-5px' }} >
                                        +
                                      </span>
                                      <span style={{ verticalAlign: "middle" }}>
                                        Add Claim
                                      </span>
                                    </button>
                                  </div>
                                </div>

                                {/* Allow Forms Authentication */}
                                <div className="form-group">
                                  <Field
                                    type="checkbox"
                                    name="allowFormsAuth"
                                  ></Field>
                                  <label htmlFor="allowFormsAuth">Allow Forms Authentication</label>
                                  <ErrorMessage
                                    component="div"
                                    name="allowFormsAuth"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </>
                            )}

                            {values.authType === 'oidcsso' && (
                              <>
                                <br></br>
                                <div><h3>SSO via OIDC</h3></div>
                                <br></br>

                                {/* Identity Provider ID */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label htmlFor="oidcIdentityProviderID">Identity Provider ID (OKTA Only)</label>
                                  <Field
                                    type="text"
                                    name="oidcIdentityProviderID"
                                    placeholder="Identity Provider ID"
                                    className={`form-control`}
                                  ></Field>
                                  <ErrorMessage
                                    component="div"
                                    name="oidcIdentityProviderID"
                                    className="invalid-feedback"
                                  />
                                </div>

                                {/* Client ID */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label htmlFor="oidcClientID">Client ID</label>
                                  <Field
                                    type="text"
                                    name="oidcClientID"
                                    placeholder="Client ID"
                                    className={`form-control`}
                                  ></Field>
                                  <ErrorMessage
                                    component="div"
                                    name="oidcClientID"
                                    className="invalid-feedback"
                                  />
                                </div>

                                {/* Configuration URL (.well-known) */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label htmlFor="oidcConfigUrl">Configuration URL (.well-known)</label>
                                  <Field
                                    type="text"
                                    name="oidcConfigUrl"
                                    placeholder="Configuration URL (.well-known)"
                                    className={`form-control`}
                                    onChange={(e) => {
                                      values.oidcConfigUrl = e.target.value;
                                      setOIDCConfigURL(e.target.value);
                                    }}
                                  ></Field>
                                  <ErrorMessage
                                    component="div"
                                    name="oidcConfigUrl"
                                    className="invalid-feedback"
                                  />
                                </div>

                                {/* Generate OpenID Connect Configuration */}
                                <div className="form-group">
                                  <button
                                    disabled={generatingOIDCConfig}
                                    className='btn btn-outline-secondary'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      generateOpenIDConnectConfiguration();
                                    }}
                                    type='button'
                                  >
                                    {generatingOIDCConfig ? <LuRefreshCcw className={"generating-config spin"} style={{ verticalAlign: "middle", marginTop: "-2px", marginRight: "10px" }}></LuRefreshCcw> : <FaCode style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-2px' }} />}

                                    <span style={{ verticalAlign: "middle" }}>
                                      {siteData?.authenticationConfig?.oidc?.configData ? 'Regenerate' : 'Generate'} OpenID Connect Configuration
                                    </span>
                                  </button>
                                </div>

                                {/* OpenID Connect Configuration Error */}
                                {generatingOIDCConfigResponse?.message && (
                                  <div className={`alert alert-${generatingOIDCConfigResponse.type === 'success' ? 'success' : 'danger'}`} role="alert">
                                    {generatingOIDCConfigResponse.message}
                                  </div>
                                )}

                                {/* OIDC Claims */}
                                {/* authenticationConfig */}
                                <div className="form-group">
                                  <label>OIDC Claims</label>
                                  <br></br>
                                  <small>Warning: Contact support if you need to change claims, as changes may result in new users being created, with no access to past experiences lost</small>
                                  <br></br>
                                  <br></br>
                                  <div className='well'>
                                    {oidcClaims?.[0] ? oidcClaims.map((claim, index) => {
                                      return (
                                        <div key={`claim-${index}`} className='well' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                          <div style={{ display: 'flex', justifyContent: 'flex-start', flex: 1 }}>
                                            <div>
              Site property <b>{claim.key}</b> is mapped from IdP property <b>{claim.value}</b>
                                            </div>
                                          </div>
                                          <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                                            <div>
                                              <button
                                                className='btn btn-outline-secondary'
                                                style={{ marginRight: '10px' }}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  editOIDCClaim(index);
                                                }}
                                              >
                                                <FaRegTrashAlt style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-5px' }} />
                                                <span style={{ verticalAlign: "middle" }}>
                Edit
                                                </span>
                                              </button>
                                              <button
                                                className='btn btn-outline-secondary'
                                                style={{ marginRight: '10px' }}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  removeOIDCClaim(index);
                                                }}
                                              >
                                                <FaRegTrashAlt style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-5px' }} />
                                                <span style={{ verticalAlign: "middle" }}>
                Delete
                                                </span>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }) : (
                                      <>
                                        <div className='well'>
                                          <small>You have no claims defined.</small>
                                        </div>
                                        <br></br>
                                      </>
                                    )}
                                    <button
                                      className='btn btn-outline-secondary'
                                      style={{ marginRight: '10px' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        addNewOIDCClaim();
                                      }}
                                    >
                                      <span style={{ verticalAlign: "middle", marginRight: '5px', marginTop: '-5px' }} >
        +
                                      </span>
                                      <span style={{ verticalAlign: "middle" }}>
        Add Claim
                                      </span>
                                    </button>
                                  </div>
                                </div>

                                {/* Allow Forms Authentication */}
                                <div className="form-group">
                                  <Field
                                    type="checkbox"
                                    name="allowFormsAuth"
                                  ></Field>
                                  <label htmlFor="allowFormsAuth">Allow Forms Authentication</label>
                                  <ErrorMessage
                                    component="div"
                                    name="allowFormsAuth"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </Tab>
                        <Tab eventKey={'branding'} title={'Branding'}>
                          <div>
                            <div><h3>Images</h3></div>
                            <br></br>

                            {/* Loading Icon */}
                            {/* brandingConfig */}
                            {/* <div className="form-group">
                              <label>Loading Icon</label>
                              <div className={`form-control asset-selector`}>
                                <PubHubAsset
                                  asset={loadingIconAsset}
                                  onChanged={(asset) => {
                                    setLoadingIconAsset(asset);
                                  }}
                                  maxFileSizeInBytes={5242880}
                                  // acceptMimeTypes={["image/png", "image/jpeg"]}
                                  assetType="image"
                                />
                              </div>
                            </div> */}

                            {/* Favicon */}
                            {/* brandingConfig */}
                            <div className="form-group">
                              <label>Favicon</label>
                              <div className={`form-control asset-selector`}>
                                <PubHubAsset
                                  asset={faviconAsset}
                                  onChanged={(asset) => {
                                    setFaviconAsset(asset);
                                  }}
                                  maxFileSizeInBytes={5242880}
                                  // acceptMimeTypes={["image/png", "image/jpeg"]}
                                  assetType="image"
                                />
                              </div>
                            </div>

                            {/* Logo */}
                            {/* brandingConfig */}
                            <div className="form-group">
                              <label>Logo</label>
                              <div className={`form-control asset-selector`}>
                                <PubHubAsset
                                  asset={logoAsset}
                                  onChanged={(asset) => {
                                    setLogoAsset(asset);
                                  }}
                                  maxFileSizeInBytes={5242880}
                                  // acceptMimeTypes={["image/png", "image/jpeg"]}
                                  assetType="image"
                                />
                              </div>
                            </div>

                            {/* Background Image (sign in page) */}
                            {/* brandingConfig */}
                            <div className="form-group">
                              <label>Background Image (sign in page)</label>
                              <div className={`form-control asset-selector`}>
                                <PubHubAsset
                                  asset={backgroundImageAsset}
                                  onChanged={(asset) => {
                                    setBackgroundImageAsset(asset);
                                  }}
                                  maxFileSizeInBytes={5242880}
                                  // acceptMimeTypes={["image/png", "image/jpeg"]}
                                  assetType="image"
                                />
                              </div>
                            </div>

                            {/* Background Image Mobile (sign in page) */}
                            {/* brandingConfig */}
                            <div className="form-group">
                              <label>Background Image Mobile (sign in page)</label>
                              <div className={`form-control asset-selector`}>
                                <PubHubAsset
                                  asset={backgroundImageMobileAsset}
                                  onChanged={(asset) => {
                                    setBackgroundImageMobileAsset(asset);
                                  }}
                                  maxFileSizeInBytes={5242880}
                                  // acceptMimeTypes={["image/png", "image/jpeg"]}
                                  assetType="image"
                                />
                              </div>
                            </div>

                            <br></br>
                            <div><h3>Text Styles</h3></div>
                            <br></br>

                            {/* Primary Colour */}
                            {/* brandingConfig */}
                            <div className="form-group">
                              <label htmlFor="primaryColour">Primary Colour</label>
                              <Field
                                type="text"
                                name="primaryColour"
                                placeholder="Primary Colour"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="primaryColour"
                                className="invalid-feedback"
                              />
                            </div>

                            {/* Text Colour */}
                            {/* brandingConfig */}
                            <div className="form-group">
                              <label htmlFor="textColour">Text Colour</label>
                              <Field
                                type="text"
                                name="textColour"
                                placeholder="Text Colour"
                                className={`form-control`}
                              ></Field>
                              <ErrorMessage
                                component="div"
                                name="textColour"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                        </Tab>
                      </Tabs>

                      <br></br>
                      <br></br>

                      {submitError && <Alert variant={"danger"}>{submitError}</Alert>}
                      {submitSuccess && (
                        <Alert variant={"success"}>{submitSuccess}</Alert>
                      )}

                      <div className="form-group">
                        {submittingForm ? (
                          <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                          </Spinner>
                        ) : (
                          <>
                            <button
                              type="submit"
                              className={`mb-2 btn btn-outline-primary ${
                                submittingForm ? "hide" : ""
                              }`}
                              style={{ marginRight: "5px" }}
                              disabled={submittingForm ? true : false}
                            >
                              Save
                            </button>
                          </>
                        )}
                      </div>
                      <br></br>
                      <br></br>

                    </Form>
                  )}
                </Formik>
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'center', justifyContent: 'center' }}>
          {loading()}
        </div>
      )}
      <Modal
        show={showAddClaimModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        title=""
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            New Claim
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={claimToEdit?.claim ? claimToEdit.claim : { key: '', value: '' }}
          validationSchema={Yup.object().shape(formValidation)}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            handleSubmit(values);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (
            <Form noValidate>
              <Modal.Body>
                <div className="form-group">
                  <label htmlFor="key">Site Property</label>
                  <Field
                    type="text"
                    name="key"
                    placeholder="Site Property (e.g. username)"
                    className={`form-control`}
                  ></Field>
                  <ErrorMessage
                    component="div"
                    name="key"
                    className="invalid-feedback"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="value">IdP Property</label>
                  <Field
                    type="text"
                    name="value"
                    placeholder="IdP Property (e.g. http://schemas.xmlsoap.org/ws/2005/05/identity/claims/employeeid)"
                    className={`form-control`}
                  ></Field>
                  <ErrorMessage
                    component="div"
                    name="value"
                    className="invalid-feedback"
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                  <Button
                    style={{ marginRight: '10px' }}
                    onClick={(e) => {
                      setClaimToEdit(null);
                      setShowAddClaimModal(false);
                    }}
                    variant="outline-secondary"
                  >
              Cancel
                  </Button>
                  {claimToEdit?.claim ? (
                    <Button
                      disabled={!values.key || !values.value}
                      onClick={(e) => {
                        confirmNewClaim(values);
                        setShowAddClaimModal(false);
                      }}
                      variant="outline-primary"
                    >
              Update
                    </Button>
                  ) : (
                    <Button
                      disabled={!values.key || !values.value}
                      onClick={(e) => {
                        confirmNewClaim(values);
                        setShowAddClaimModal(false);
                      }}
                      variant="outline-primary"
                    >
              Add
                    </Button>
                  )}
                </div>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/* <ConfirmationModal
        title={
          siteData && siteData.providerData && siteData.providerData.displayName
            ? siteData.providerData.displayName
            : siteData.sitename
        }
        body={
          <>
            <p className={deleteMessageShow ? "hide" : ""}>
              {siteData && siteData.status === 'Active' ? (
                <Alert variant={"warning"}>
                  This record is linked to an external data source that may
                  overwrite your changes
                </Alert>
              ) : null}
              <br></br>
              Are you sure you want to delete this site?
            </p>
            <p className={deleteMessageShow ? "" : "hide"}>
              The delete will be done within the next few minutes.
            </p>
          </>
        }
        show={deleteModalShow}
        confirmtext={"Delete"}
        onHide={(event, exitValue) => {
          if (!deleteMessageShow) {
            confirmDelete(event, exitValue);
          }
        }}
        showspinner={deleteMessageShow}
      /> */}
    </div>
  );
}
